import { ImageTextCol } from '@definitions/types/storyblokTypes'

import { createStoryblokAsset } from '../../../../../__mocks__/storyblok/createStoryblokAsset'
import { createStoryblokMultilink } from '../../../../../__mocks__/storyblok/createStoryblokMultilink'
import { createStoryblokRichtext } from '../../../../../__mocks__/storyblok/createStoryblokRichtext'

/**
 * Creates a mock ImageTextCol
 * @param overrides - Partial fields to override defaults
 * @returns Complete ImageTextCol mock
 */
export function createImageTextCol(
  overrides: Partial<ImageTextCol> = {}
): ImageTextCol {
  return {
    _uid: 'ce5baf00-f0b1-43d1-818a-d87cb2116a31',
    link: createStoryblokMultilink({
      id: '589e3df3-f7df-4728-989e-8cbdf37e6209',
      linktype: 'story',
      cached_url: 'sunpoint/braeune/solarium',
    }),
    image: createStoryblokAsset({
      id: 10414769,
      alt: 'Sonnenbank',
      title: 'Sonnenbank',
      filename:
        'https://a.storyblok.com/f/235453/384x288/01074d2bf9/sonnenbank.png',
      src: 'https://a.storyblok.com/f/235453/384x288/01074d2bf9/sonnenbank.png',
      width: 384,
      height: 288,
      aspect_ratio: 1.33,
      content_type: 'image/png',
      updated_at: '2024-01-01T00:00:00.000Z',
    }),
    content: createStoryblokRichtext('sadsdasdd'),
    headline: 'ssdsadsdads',
    component: 'image-text-col',
    _editable:
      '<!--#storyblok#{"name": "image-text-col", "space": "235453", "uid": "ce5baf00-f0b1-43d1-818a-d87cb2116a31", "id": "322787899"}-->',
    ...overrides,
  }
}
